// Application constants

// API limits - optimized for faster initial loading
export const API_PAGE_LIMITS = {
  JOBS: 15,          // Reduced from 20 for faster initial load
  PROPERTIES: 50,    // Reduced from 100 for faster loading
  USERS: 30,         // Reduced from 50 for faster loading
  RESERVATIONS: 15   // Reduced from 20 for faster loading
};

// Default display limits
export const DISPLAY_LIMITS = {
  JOBS: 20,          // Jobs initially shown in UI
  PROPERTIES: 10,    // Properties shown in dropdowns
  ASSIGNMENTS: 20    // Assignments shown per page
}; 